export const parsePositionValue = (value: string | number) => {
  if (!value) {
    return 0;
  }

  if (typeof value === 'string') {
    return Number(value.replace(/,/g, ''));
  }

  return value;
};
